import { render, staticRenderFns } from "./NotificationRecurringOrderProductNotActive.vue?vue&type=template&id=031ff7ea&"
import script from "./NotificationRecurringOrderProductNotActive.vue?vue&type=script&lang=js&"
export * from "./NotificationRecurringOrderProductNotActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports